import { useContext, useRef, useState } from "react";
import FormButton from "./FormButton";
import { AppContext } from "../../../contextApi/ContextApi";

export default function FormTextarea({hasButton=false, buttonText, buttonAction, resetValue=false, label, id, _value, placeholder, onChangeAction, required=null, editFlag=true, _ref}) {
  const {primary_color, accent_color} = useContext(AppContext);
  const inputRef = useRef();
  const [showFullValue, setShowFullValue] = useState(false);
  return (
    <div className={hasButton ? "dashboardForm_section_withBtn" :"dashboardForm_section"}>
        <label htmlFor={id}>{label}</label>
        {editFlag ? <textarea
          ref={resetValue ? inputRef : _ref}
          id={id}
          value={_value}
          placeholder={placeholder}
          onChange={onChangeAction}
          required={required}
          dir="rtl"
        ></textarea> : 
        <p onMouseEnter={()=>{setShowFullValue(true)}} onMouseLeave={()=>{setShowFullValue(false)}}>
          {_value.length>30 ? `${_value.slice(0,30)}...` : _value}
          {_value.length>30&&showFullValue ? <span className="dashboardForm_section_textarea_fullValue" style={{backgroundColor:accent_color, color:primary_color}}>{_value}</span> : null}
        </p>}
        {hasButton ? <FormButton disabled={false} type={"button"} text={buttonText} action={()=>{buttonAction(); if(resetValue){inputRef.current.value = ""}}}/> : null}
    </div>
  )
}
